import { useEffect } from "react";
import { Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import { useRefreshToken } from "../hooks/mutations/login-mutation";
import { useAuth } from "../context/AuthContext";

const RootLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { updateAuth, clearAuth } = useAuth();

  useEffect(() => {
    const accessToken = Cookies.get("access");
    const refreshToken = Cookies.get("refresh");

    if (refreshToken && !accessToken) refreshTokenMutation.mutate({ refreshToken });
  }, [navigate, location.pathname]);

  const refreshTokenMutation = useRefreshToken({
    onSuccess: (res) => {
      clearAuth();
      Cookies.set("access", res?.access as string, { expires: 1 });
      Cookies.set("refresh", res?.refresh as string, { expires: 30 });
      Cookies.set("role", res?.user?.role as string, { expires: 30 });
      Cookies.set("org_id", res?.user?.org_id?.toString() as string, {
        expires: 30,
      });
      Cookies.set("user_id", res?.user?.id?.toString() as string, {
        expires: 30,
      });
      Cookies.set("first_name", res?.user?.firstName?.toString() as string, {
        expires: 30,
      });
      Cookies.set("last_name", res?.user?.lastName?.toString() as string, {
        expires: 30,
      });
      Cookies.set("email", res?.user?.email?.toString() as string, {
        expires: 30,
      });
      updateAuth(
        res.user.role as any,
        String(res.user.org_id),
        String(res.user.org_name),
        String(res.user.id),
        res.user.firstName,
        res.user.lastName,
        String(res.user.email),
        true
      );
      const backto = searchParams.get("backto");
      if (backto) {
        navigate(decodeURIComponent(backto).replace(/^\/+/, "/"), { replace: true });
      } else {
        navigate("/home");
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div className="flex flex-col h-screen w-screen">
      {/* Main Content */}
      <div className="flex-1 min-h-0 w-full overflow-hidden h-full">
        <div className="w-full h-full overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default RootLayout;
